<template>
  <div class="home">
    <!-- <div class="jzgg_title">
      <span>{{ $i18n.t("lectures1") }}</span>
    </div>
    <div class="jzgg_line">
      <div class="jzgg_line-item"></div>
    </div>
    <div class="box_item">
      <div class="box_item_lt">
        <div class="address">{{ $i18n.t("lectures2") }}</div>
        <div class="time">9:00-12:00</div>
        <div class="box_item_line"></div>
      </div>
      <div @click="goPage(1)" class="box_item_rt">
        {{ $i18n.t("info1") }}
      </div>
    </div> -->


    <!-- <div class="jzgg_title">
      <span>{{ $i18n.t("lectures2_1") }}</span>
    </div>
    <div class="jzgg_line">
      <div class="jzgg_line-item"></div>
    </div>
    <div class="box_item">
      <div class="box_item_lt">
        <div class="address">{{ $i18n.t("lectures2_2") }}</div>
        <div class="time">9:30-12:00</div>
        <div class="box_item_line"></div>
      </div>
      <div @click="goPage(2)" class="box_item_rt">
        {{ $i18n.t("info2_1") }}
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Lectures",
  methods: {
    goPage(type) {
      if(type == 1){
        this.$router.push("/lectures/lecturesinfo");
      }else if(type == 2){
        this.$router.push("/lectures/lecturesinfo2");
      }
    },
  },
};
</script>
<style scoped >
.home {
  padding-bottom: 100px;
}
.jzgg_title {
  margin-top: 156px;
  font-weight: bold;
  font-size: 30px;
  color: #ffffff;
}
.jzgg_line {
  height: 2px;
  background: #ffffff;
  position: relative;
  margin-top: 26px;
  margin-bottom: 40px;
}
.jzgg_line-item {
  width: 202px;
  height: 8px;
  position: absolute;
  left: 0;
  top: -3px;
  background: #fff;
}
.box_item {
  display: flex;
  margin-top: 40px;
}
.box_item_lt {
  width: 420px;
  position: relative;
}
.address {
  font-weight: 500;
  font-size: 30px;
  color: #ffffff;
}
.time {
  font-weight: bold;
  font-size: 50px;
  margin: 10px 0;
  color: #ffffff;
}
.notice {
  font-weight: 500;
  font-size: 28px;
  color: #ffffff;
}
.box_item_line {
  width: 1px;
  height: 120px;
  background: #dfdfdf;
  position: absolute;
  right: 0;
  top: 21px;
}
.box_item_rt {
  margin-left: 115px;
  margin-top: 50px;
  cursor: pointer;
  font-weight: 400;
  font-size: 36px;
  color: #ffffff;
}
</style>